import { Navigate, useLocation } from "react-router-dom";
import { getAuthToken, getUser, clearAuthData } from "../utils/storage";

export default function PrivateRoute({ module, children }) {
  const location = useLocation();

  const token = getAuthToken();

  // No token → redirect to login
  if (!token) {
    clearAuthData();

    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  // Check module-level RBAC permission
  if (module) {
    const user = getUser();
    const hasAccess = user?.permissions?.[module]?.view;

    if (!hasAccess) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Token exists + permission granted → allow access
  return children;
}
